var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator"},[_c('span',{staticClass:"spinner",style:(_vm.getStyles),domProps:{"textContent":_vm._s(_vm.translate('lblLoading'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }